import React, { useState, useEffect } from 'react';
import validate from 'validate.js';
import { connect } from "react-redux";
import * as actions from "redux/actions/optionOrderActions";
import * as actions_stock from "redux/actions/stockActions";
import ListStockSelect from 'components/ListStockSelect';
import { Translate, I18n } from "react-redux-i18n";
import InputDate from 'components/InputDate';
import {Trash} from "theme/icon";

const schema = {
    symbol: {
        presence: { allowEmpty: false, message: 'is required' },
        length: {
            maximum: 300
        }
    },
    /*   market: {
           presence: { allowEmpty: false, message: 'is required' },
           length: {
               maximum: 50
           }
       },
       option_kind: {
           presence: { allowEmpty: false, message: 'is required' },
           length: {
               maximum: 50
           }
       },*/
}

function dateToYMD(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
}

const FormDialog = (props) => {

    const [open, setOpen] = React.useState(false);

    const [dialogState, setDialogState] = useState({
        isValid: false,
        values: {
            symbol: "",
            name: "",
            open_at: new Date().toISOString().split('T')[0],
            id: props.user_id,
            reference: "",
            share: false,
            quantity: 1,
            expire_at: new Date().toISOString().split('T')[0],
            leg: [
                {
                    open_price: 0.01,
                    strike: 1,
                    market: "",
                    option_kind: "",
                    expire_at: new Date().toISOString().split('T')[0],
                    quantity: 1,
                }
            ]
        },
        touched: {},
        errors: {}
    });

    useEffect(() => {
        const errors = validate(dialogState.values, schema);
        setDialogState(dialogState => ({
            ...dialogState,
            isValid: errors ? false : true,
            errors: errors || {}
        }));
    }, [dialogState.values]);

    const handleClickOpen = () => {
        setOpen(true);
        setDialogState({
            isValid: false,
            values: {
                symbol: "",
                name: "",
                open_at: new Date().toISOString().split('T')[0],
                id: props.user_id,
                reference: "",
                share: false,
                quantity: 1,
                expire_at: new Date().toISOString().split('T')[0],
                leg: [
                    {
                        open_price: 0.01,
                        strike: 1,
                        market: "",
                        option_kind: "",
                        expire_at: new Date().toISOString().split('T')[0],
                        quantity: 1,
                    }
                ]
            },
            touched: {},
            errors: {}
        });
    };

    const handleClose = () => {
        setOpen(false);
        props.resetList();
    };

    const handleSave = async () => {
        await props.newStrategy(dialogState.values, props.token);
        await props.loadList(props.user_id, props.token);
        setOpen(false);
    };

    const handleSaveShare = async (event) => {
        await props.newStrategy({ ...dialogState.values, share: true }, props.token);
        await props.loadList(props.user_id, props.token);
        setOpen(false);
    };

    const handleChange = (event) => {
        event.persist();
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                [event.target.name]: event.target.value
            },
            touched: {
                ...dialogState.touched,
                [event.target.name]: true
            }
        }));
    };

    const handleChangeSymbol = (event) => {
        event.persist();
        if (event.target.value.trim() !== dialogState.values.symbol) {
            setDialogState(dialogState => ({
                ...dialogState,
                values: {
                    ...dialogState.values,
                    [event.target.name]: event.target.value.trim(),
                    name: ""
                },
                touched: {
                    ...dialogState.touched,
                    [event.target.name]: true
                }
            }));
            props.searchList({ id: props.user_id, search: event.target.value }, props.token);
        } else props.resetList();
    };

    const handleChangeLeg = (i, e) => {
        let leg = dialogState.values.leg;
        if (i === 0 && e.target.name === "expire_at") {
            for (let i = 0; i < leg.length; i++) {
                leg[i][e.target.name] = e.target.value;
            }
        } else
            leg[i][e.target.name] = e.target.value;

        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                leg: leg
            },
        }));
    };

    const handleChangeStrategy = (event) => {
        event.persist();
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                [event.target.name]: event.target.value,
            },
        }));

        addLegStrategy(event.target.value);
    }

    const onClickSelected = (item) => {
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                symbol: item.symbol,
                name: item.name
            },
        }));
        props.resetList();
    };

//     document.addEventListener('click', function(event) {
//       // console.log('event',event.target.id);
//       // && event.target.id != 'menu_swall'
//       if(event.target.id != 'list-stock-select' ){
//       // document.getElementById('menu').style.display = 'none';
//         props.resetList();
//         setDialogState(dialogState => ({
//             ...dialogState,
//             values: {
//                 ...dialogState.values,
//                 symbol: "",
//                 name: ""
//             },
//         }));
//     }
//   });

//   document.addEventListener('keydown', function(event) {
//     if (event.key === 'Escape') {
//         // Replace '.my-button' with your element's selector
//         // document.querySelector('.my-button').style.display = 'none';
//          props.resetList();
//          setDialogState(dialogState => ({
//             ...dialogState,
//             values: {
//                 ...dialogState.values,
//                 symbol: "",
//                 name: ""
//             },
//         }));
//     }
// });

    /*const getLeg = (strategy) => {
        let leg = 0;
        option_strategy.forEach(element => {
            if (element.value === strategy)
                leg = element.leg;
        });
        return leg;
    }*/

    const addLegStrategy = (strategy) => {

        switch (strategy) {
            case "Calendar":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            }
                        ],
                    },
                }));
                break;

            case "Diagonal":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            }
                        ],
                    },
                }));
                break;

            case "Straddle":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            }
                        ],
                    },
                }));
                break;

            case "IronCondor":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "PUT",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "PUT",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            }
                        ],
                    },
                }));
                break;

            case "IronButterfly":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },

                        ],
                    },
                }));
                break;

            case "CallCreditSpread":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            }
                        ],
                    },
                }));
                break;

            case "PutCreditSpread":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "PUT",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "PUT",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            }
                        ],
                    },
                }));
                break;

            case "CallDebitSpread":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "CALL",
                                expire_at: dialogState.values.expire_at,
                                quantity: dialogState.values.quantity,
                            }
                        ],
                    },
                }));
                break;

            case "PutDebitSpread":
                setDialogState(dialogState => ({
                    ...dialogState,
                    values: {
                        ...dialogState.values,
                        leg: [
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "SELL",
                                option_kind: "PUT",
                                expire_at: dialogState.values.expire_at,
                                quantity: "1",
                            },
                            {
                                open_price: 0.01,
                                strike: 1,
                                market: "BUY",
                                option_kind: "PUT",
                                expire_at: dialogState.values.expire_at,
                                quantity: "1",
                            }
                        ],
                    },
                }));
                break;

            default: break;
        }
    }

    const handleAdd = (event) => {
        if (dialogState.values.leg.length < 4)
            setDialogState(dialogState => ({
                ...dialogState,
                values: {
                    ...dialogState.values,
                    leg: [
                        ...dialogState.values.leg,
                        {
                            quantity: 1,
                            open_price: 0.01,
                            strike: 1,
                            market: "",
                            option_kind: "",
                            expire_at: new Date().toISOString().split('T')[0],
                        }
                    ],
                },
            }));
    };

    const handleRemove = (i) => {
        let leg = dialogState.values.leg;
        leg.splice(i, 1);
        setDialogState(dialogState => ({
            ...dialogState,
            values: {
                ...dialogState.values,
                leg: leg,
            },
        }));
    }
    const option_kind = [
        {
            value: "CALL",
            label: "Call",
        },
        {
            value: "PUT",
            label: "Put",
        },
    ];

    const option_market = [
        {
            value: "SELL",
            label: "STO",
        },
        {
            value: "BUY",
            label: "BTO",
        },
    ];

    const option_strategy =
        [
            {
                value: "Calendar",//hay Put y Call
                label: "Calendar",
                leg: 2
            },
            {
                value: "Diagonal",
                label: "Diagonal",
                leg: 2
            },
            {
                value: "Straddle",
                label: "Straddle",
                leg: 2
            },
            {
                value: "Strangle",//hay call y put
                label: "Strangle",
                leg: 2
            },
            {
                value: "IronCondor",
                label: "IronCondor",
                leg: 4
            },
            {
                value: "IronButterfly",
                label: "IronButterfly",
                leg: 4
            },

            {
                value: "CallCreditSpread",
                label: "CallCreditSpread",
                leg: 2
            },
            {
                value: "PutCreditSpread",
                label: "PutCreditSpread",
                leg: 2
            },
            {
                value: "CallDebitSpread",
                label: "CallDebitSpread",
                leg: 2
            },
            {
                value: "PutDebitSpread",
                label: "PutDebitSpread",
                leg: 2
            },
            {
                value: "Another",
                label: "Another",
                leg: 1
            },
        ];

    const hasError = field =>
        dialogState.touched[field] && dialogState.errors[field] ? true : false;

    return (
        <div className="entry-strategy-trigger">
            <button type="button" className="btn btn-primary" onClick={handleClickOpen}>
                <Translate value="strategy" />
            </button>
            {open && (
                <div className="dialog" role="presentation" onClick={handleClose}>
                    <div
                        className="dialog-content dialog-content--entry-wide"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="strategy-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="dialog-title" id="strategy-modal-title">Option Strategy</h2>
                        <p className="dialog-content-text">Multi-leg option strategy entry</p>

                        <div className="entry-form">
                            <div className="entry-form-grid entry-form-grid--3">
                                <div className="symbol-search-wrap">
                                    <div className="entry-field">
                                        <label htmlFor="strategy-symbol">Symbol</label>
                                        <input
                                            id="strategy-symbol"
                                            name="symbol"
                                            type="text"
                                            required
                                            onChange={handleChangeSymbol}
                                            autoComplete="off"
                                            value={(dialogState.values.symbol || '').toUpperCase()}
                                        />
                                    </div>
                                    {dialogState.values.symbol.length > 0 && !dialogState.values.name && (
                                        <ListStockSelect
                                            list={props.list}
                                            loading={props.loading}
                                            onClickSelected={onClickSelected}
                                        />
                                    )}
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="strategy-name">Company</label>
                                    <input
                                        id="strategy-name"
                                        name="name"
                                        type="text"
                                        disabled
                                        value={dialogState.values.name}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="entry-field">
                                    <label htmlFor="strategy-reference">Strategy</label>
                                    <select
                                        id="strategy-reference"
                                        name="reference"
                                        value={dialogState.values.reference}
                                        onChange={handleChangeStrategy}
                                    >
                                        <option value="">Select strategy</option>
                                        {option_strategy.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="entry-leg-list">
                                {dialogState.values.leg.map((element, index) => (
                                    <div className="entry-leg-card" key={index}>
                                        <div className="entry-leg-header">
                                            <span className="entry-leg-title">Leg {index + 1}</span>
                                            {dialogState.values.leg.length > 1 && (
                                                <button
                                                    type="button"
                                                    className="entry-leg-remove"
                                                    onClick={() => handleRemove(index)}
                                                    aria-label="Remove leg"
                                                >
                                                    <Trash />
                                                </button>
                                            )}
                                        </div>
                                        <div className="entry-form-grid entry-form-grid--3">
                                            <div className="entry-field">
                                                <label htmlFor={`leg-qty-${index}`}>Contracts</label>
                                                <input
                                                    id={`leg-qty-${index}`}
                                                    name="quantity"
                                                    type="number"
                                                    min="1"
                                                    required
                                                    value={element.quantity || ''}
                                                    onChange={(e) => handleChangeLeg(index, e)}
                                                />
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`leg-market-${index}`}>Side</label>
                                                <select
                                                    id={`leg-market-${index}`}
                                                    name="market"
                                                    required
                                                    value={element.market || ''}
                                                    onChange={(e) => handleChangeLeg(index, e)}
                                                >
                                                    <option value="">STO / BTO</option>
                                                    {option_market.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`leg-kind-${index}`}>Type</label>
                                                <select
                                                    id={`leg-kind-${index}`}
                                                    name="option_kind"
                                                    required
                                                    value={element.option_kind || ''}
                                                    onChange={(e) => handleChangeLeg(index, e)}
                                                >
                                                    <option value="">Call / Put</option>
                                                    {option_kind.map((option) => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`leg-expire-${index}`}>Expiration</label>
                                                <InputDate
                                                    id={`leg-expire-${index}`}
                                                    name="expire_at"
                                                    required
                                                    label=""
                                                    value={element.expire_at || ''}
                                                    onChange={(e) => handleChangeLeg(index, e)}
                                                />
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`leg-strike-${index}`}>Strike</label>
                                                <input
                                                    id={`leg-strike-${index}`}
                                                    name="strike"
                                                    type="number"
                                                    min="0.01"
                                                    step="0.01"
                                                    required
                                                    value={element.strike || 1}
                                                    onChange={(e) => handleChangeLeg(index, e)}
                                                />
                                            </div>
                                            <div className="entry-field">
                                                <label htmlFor={`leg-price-${index}`}>Premiun/Debit</label>
                                                <input
                                                    id={`leg-price-${index}`}
                                                    name="open_price"
                                                    type="number"
                                                    min="0.01"
                                                    step="0.01"
                                                    required
                                                    value={element.open_price || 0.01}
                                                    onChange={(e) => handleChangeLeg(index, e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="entry-field">
                                <label htmlFor="strategy-open_at">Open date</label>
                                <InputDate
                                    id="strategy-open_at"
                                    name="open_at"
                                    required
                                    label=""
                                    value={dialogState.values.open_at}
                                    onChange={handleChange}
                                    min="1900-01-01"
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>

                            <div className="dialog-actions">
                                <button type="button" className="btn btn-secondary" onClick={handleAdd}>
                                    <Translate value="add_leg" />
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                    <Translate value="cancel" />
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!dialogState.isValid}
                                    onClick={handleSaveShare}
                                >
                                    <Translate value="save_share" />
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!dialogState.isValid}
                                    onClick={handleSave}
                                >
                                    <Translate value="save" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function mapStateToProps(reducer) {
    //console.log(reducer);
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,

        item: {},

        list: reducer.stock.list,
        error: reducer.stock.error,
        loading: reducer.stock.loading,

    };
}
const mapDispatchToProps = dispatch => ({
    newStrategy: (params, token) =>
        dispatch(actions.newStrategy({ params, token })),
    loadList: (user_id, token) =>
        dispatch(actions.loadList({ user_id, token })),
    searchList: (params, token) =>
        dispatch(actions_stock.searchList({ params, token })),
    resetList: () =>
        dispatch(actions_stock.resetList({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormDialog);


/**
 *   <div style={{ "display": "flex", "justifyContent": "space-between" }}>
                    </div>
 *  <div>
                            <TextField
                                margin="dense"
                                id="quantity"
                                name="quantity"
                                required="true"
                                label="Quantity"
                                type="number"
                                min="1"
                                value={dialogState.values.quantity}
                                onChange={handleChange}
                                // fullWidth
                                sx={{ m: 1, width: '10ch' }}
                                variant="standard"
                            />
                            {"  "}
                            <TextField
                                margin="dense"
                                id="expire_at"
                                name="expire_at"
                                required="true"
                                label="Expire Date "
                                type="date"
                                value={dialogState.values.expire_at || ""}
                                onChange={handleChange}
                                variant="standard"
                            />
                        </div>
 */